import React from 'react';
import { IGhgEmissionReport, IGhgFuelRow, IGhgScenario } from 'models/ghg-emission-report';
import { emission, percent, TCO2E } from './format';

interface GhgScenarioFuelTableProps {
    title: string;
    report: IGhgEmissionReport;
    scenario: IGhgScenario;
    /** Picks the per-fuel prognosis column this scenario shows. */
    prognosisOf: (fuel: IGhgFuelRow) => number;
}

export default function GhgScenarioFuelTable(props: GhgScenarioFuelTableProps) {
    const report = props.report;

    return (
        <div className="ghg-scenario-table">
            <h4 className="u-fs-16 font-weight-bold mb-3">{props.title}</h4>

            <div className="table-responsive">
                <table className="table ghg-table mb-0">
                    <thead>
                        <tr>
                            <th>Transpordikütus</th>
                            <th className="text-right">
                                Võrdlusheide
                                <span className="ghg-table__subhead">(100% fossiilkütus)</span>
                            </th>
                            <th className="text-right">Perioodi tegelik heide</th>
                            <th className="text-right">Prognoositav heide</th>
                        </tr>
                    </thead>
                    <tbody>
                        {report.fuels.map(fuel => {
                            return (
                                <tr key={fuel.fuelType}>
                                    <td>{fuel.label}</td>
                                    <td className="text-right">{emission(fuel.fossilReference)}</td>
                                    <td className="text-right">{emission(fuel.emission)}</td>
                                    <td className="text-right">{emission(props.prognosisOf(fuel))}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="font-weight-bold">
                            <td>Kokku</td>
                            <td className="text-right">{emission(report.fossilReference)}</td>
                            <td className="text-right">{emission(report.actualEmission)}</td>
                            <td className="text-right">{emission(props.scenario.prognosisEmission)}</td>
                        </tr>
                        <tr>
                            <td colSpan={3}>Välditud KHG-heide kokku</td>
                            <td className="text-right">{emission(props.scenario.avoidedTotal)}</td>
                        </tr>
                        <tr>
                            <td colSpan={3}>Heite vähenemine kokku</td>
                            <td className="text-right">{percent(props.scenario.reductionPct)}%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <p className="ghg-table__footnote">Kõik väärtused {TCO2E} (v.a protsent).</p>
        </div>
    );
}
